webpackJsonp([114276838955818,60335399758886],{

/***/ 129:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"XFL.com - Official home of the XFL","mailchimp":"https://tttkd1j8qh.execute-api.us-east-1.amazonaws.com/dev/signup","description":"Get ready for the greatest comeback in sports history. The XFL returns in 2020.","startDate":"2020-09-08 18:00:00","passProtect":"true","showCities":true}},"contactModal":{"edges":[{"node":{"label":"contactus","title":"Contact Us","content":{"childMarkdownRemark":{"html":"<p><strong>EMAIL</strong></p>\n<p>General / <a href=\"https://info@xfl.com\">info@xfl.com</a></p>\n<p>Tickets / <a href=\"https://tickets@xfl.com\">tickets@xfl.com</a> </p>\n<p>Media / <a href=\"https://media@xfl.com\">media@xfl.com</a></p>\n<p>-</p>\n<p><strong>PHONE</strong></p>\n<p>League Headquarters / (203) 989-3399</p>\n<p>Dallas / (469) 458-9099 / <a href=\"https://dallas@xfl.com\">dallas@xfl.com</a></p>\n<p>Houston / (832) 306-3100 / <a href=\"https://houston@xfl.com\">houston@xfl.com</a></p>\n<p>Los Angeles / (424) 279-8100 / <a href=\"https://losangeles@xfl.com\">losangeles@xfl.com</a></p>\n<p>New York / (917) 781-2300 / <a href=\"https://newyork@xfl.com\">newyork@xfl.com</a></p>\n<p>St. Louis / (314) 356-9920 / <a href=\"https://stlouis@xfl.com\">stlouis@xfl.com</a></p>\n<p>Seattle / (206) 960-4995 / <a href=\"https://seattle@xfl.com\">seattle@xfl.com</a></p>\n<p>Tampa Bay / (813) 559-0444 / <a href=\"https://tampabay@xfl.com\">tampabay@xfl.com</a></p>\n<p>Washington DC / (202) 795-2201 / <a href=\"https://washingtondc@xfl.com\">washingtondc@xfl.com</a></p>\n<p>-</p>\n<p><strong>MAIL</strong></p>\n<p>XFL </p>\n<p>1266 East Main Street</p>\n<p>Stamford, CT 06902</p>"}}}}]},"privacyModal":{"edges":[{"node":{"label":"privacy","title":"Privacy Policy","content":{"childMarkdownRemark":{"html":"<p>Alpha Entertainment LLC d/b/a XFL owns and operates websites, including without limitation, XFL.com  (collectively, the “Services”), including the website you have entered. This Privacy Policy applies to the Services unless we have posted a special Privacy Policy to a particular website, in which case the special Privacy Policy terms apply to that website or service to the extent that they are different from this Privacy Policy.</p>\n<p>Please note that this Privacy Policy contains capitalized words or phrases. These words and phrases are defined terms. Their definitions are found either in this Privacy Policy or in our Terms and Conditions of Use (\"Terms of Use\"). If you have a privacy or data use concern that we have not addressed satisfactorily in this Privacy Policy, please contact us at <a href=\"https://info@xfl.com\">info@xfl.com</a>.</p>\n<p>We want to help you make the most of your use of our Services, and that includes helping to protect your personal privacy. Most of the features on our Services are offered without collecting any Personal Information (defined below) from you; however, some features require you to provide your Personal Information. For example, when you make a purchase you are required to submit Personal Information in connection with our providing various products and services to you. You may also submit content of your own in areas of our Services, and some of that User-Generated Content may contain Personal Information. For those aspects of our Services that do require us to collect Personal Information or allow voluntary submission of Personal Information, this Privacy Policy will offer suggestions on how to make good decisions for yourself and your family.</p>\n<p>This Privacy Policy discloses when and how we collect, use, share, and safeguard information from our Services. The Personal Information we collect depends on what you do when you visit our websites or use the various products or services we offer. This Privacy Policy also explains what to do if you do not want to provide Personal Information when you use our Services, and how to correct, change or delete some information you have already provided to us.\nBy using these Services, you are agreeing to the terms of this Privacy Policy. If you do not agree with any terms or practices described in this Privacy Policy, please do not use our Services or provide your Personal Information to us.</p>\n<p>As used in this Privacy Policy, \"Personal Information\" means any information by which a particular natural person is reasonably identifiable.</p>\n<p>Personal Information includes, for example, a first name or initial and last name; a home or other physical address; a date of birth; an e-mail address or other online contact information; or a telephone number. When Personal Information is collected, you will often know because you will be providing it to us; for example, you may fill out a form on the website or submit information via your account or profile, or in connection with requesting various products or services. When you make a purchase we will also collect additional Personal Information such as your credit or debit card information or information concerning any other payment mechanism we accept (“Payment Information”). We will use your Personal Information (including your Payment Information) as described in this Privacy Policy and will use your Payment Information to process and complete the transactions you have requested.</p>\n<h3>CHILDREN</h3>\n<p>We are committed to providing special protection for the privacy of children who may visit our Services. We encourage parents to spend time online with their children, become familiar with the features of our Services and participate in the activities offered on our Services. Our protections for the privacy of children include the following:</p>\n<p>We do not knowingly solicit, collect, use or retain any Personal Information, for any purpose whatsoever (including internal or external marketing or promotional purposes), from visitors to these Services who are under the age of 13. In addition, we will delete any records of such Personal Information that come to our attention.</p>\n<p>We do not allow visitors who we know are under the age of 13 to be listed in any directory of registered users, to participate in any of our chat services, to register for contests, sweepstakes, promotions, or newsletters, or to receive direct marketing from us or from our third-party affiliates or service or product providers.</p>\n<p>We do collect Personal Information as part of registration processes so that users can obtain certain services, such as newsletters, and so that they can set up accounts or profiles. Our Terms of Use expressly prohibits persons under the age of 13 from opening such accounts or profiles. We do not knowingly allow children to register and our Services may employ features and procedures that are intended to help prevent under-age registrations. If we believe that a person who is under the age of 13 has registered with us or set up a profile, account, or has otherwise provided information to us without our knowing the person was a child, we may terminate that registration and undertake commercially reasonable efforts to delete any Personal Information we have obtained, including all content from any profile or account.</p>\n<p>We recommend that minors who are age 13 or older consult with their parents before sending any information about themselves over the internet.</p>\n<p>If we believe a person is under the age of 18, we also retain the right to refuse to process or delete their Personal Information and any Personal Information which they might provide in respect of anyone else, or to stop them from participating in any related features or services, unless they are able to prove to our reasonable satisfaction that they are over the age of 18 or have any (if any) appropriate parental consent to provide Personal Information to us.</p>\n<h3>SPECIAL NOTE TO PARENTS</h3>\n<p>If you become aware that your child has provided us with Personal Information at one of our Services, we invite you to notify us so that we may delete the information from our records and discontinue any related features or services (see \"Opt-Out\" below). We appreciate your cooperation in assisting us to provide a safe and enjoyable online experience for your children.</p>\n<h3>SOCIAL MEDIA FEATURES</h3>\n<p>Our Services may include Social Media Features, such as the Facebook Like button. These Features may collect your IP address, which page you are visiting on our site, and may set a cookie to enable the Feature to function properly. Social Media Features and Widgets are either hosted by a third party or hosted directly on our site. Your interactions with these Features are governed by the privacy policy of the company providing it.</p>\n<h3>COLLECTION OF PERSONAL INFORMATION</h3>\n<p>We collect Personal Information from users of our Services in a number of ways. These may include the following:</p>\n<p>Subscriptions to our free newsletters, which include updates, special offers and promotions. Participation in contests and sweepstakes. Registrations to receive free downloadable desktop applications (e.g., screensavers). Registrations to send electronic greeting cards. Registrations for individual accounts or profiles. Purchases of merchandise and any other products or services currently offered. E-mail transmitted via various links on our Services. Use of the Services, such as links clicked and items placed in your shopping cart. Registrations for Single Sign-On or other accounts. The use of any of these services is entirely optional and voluntary; however, if you do not provide the Personal Information requested, you might not be able to register or we may elect to not make the related services available for your use. If you send us an e-mail in which you disclose Personal Information, we will use it to discuss the subject of your correspondence and, if appropriate, share it with other interested parties (such as manufacturers of merchandise you have purchased from a website).</p>\n<p>In each case where you submit Personal Information to us via one of our Services, you will be transmitting your Personal Information for processing in the United States of America, where XFL is headquartered. Your Personal Information may also need to be transferred, and processed, in other locations outside of your home country. For more information on this, please see the section below entitled: Worldwide Transfers and Processing of Personal Information.</p>\n<p>If you send us an e-mail, you should know that e-mail is not necessarily secure against interception. So, if your communication needs to include sensitive information like your Payment Information or social security number, please contact us by postal mail or telephone (see \"Contact Us\" below) rather than e-mail.</p>\n<p>We collect your location-based information for the purpose of detecting your location so that we may serve you the correct version of the application, (for instance country, state, city and/or zip code) and display targeted advertising and relevant data to you. Examples of ways in which we use your location-based information include, without limitation, to display what events are near you, serve relevant advertising to you, target push notifications/alerts and determine what is shown in the main navigation. We do not use location services to collect any data. We will only share this information with our mapping provider for the sole purpose of providing you the Services.</p>\n<p>We may provide you the opportunity to participate in contests on our Services. If you participate, we will request certain Personal Information from you. Participation in these contests is completely voluntary and you therefore have a choice whether or not to disclose this information. The requested information typically includes contact information (such as name and shipping address), and demographic information (such as city, state, zip code). We also use this information to notify contest winners and award prizes.</p>\n<p>We may also request a video submission containing your physical likeness, height, weight and other Personal Information you voluntarily disclose in the video. We may display user-created video submissions, the user's name, self-identified \"nickname\" and location (city, state and country) on our Services. Such submissions may be posted to the website and will be visible to other users and visitors of the Services.</p>\n<h3>TRACKING TECHNOLOGIES</h3>\n<p>Technologies such as: cookies, beacons, tags, scripts, and similar technologies are used by us, our affiliates and advertising partners and our partners who serve content on our Services. We do not respond to browser do-not-track signals at this time.</p>\n<h3>LOG FILES</h3>\n<p>As is true of most websites, we gather certain information automatically through our Services and store such information in log files. This information may include internet protocol (IP) addresses, browser type, internet service provider (ISP), referring/exit pages, operating system, date/time stamp, and/or clickstream data. We do not link this automatically collected data to other information we collect about you.</p>\n<h3>PUSH NOTIFICATIONS</h3>\n<p>We send you push notifications from time-to-time in order to update you about any events or promotions that we may be running. If you no longer wish to receive these types of communications, you may turn them off at the device level. To ensure you receive proper notifications, we will need to collect certain information about your device such as operating system and user identification information.</p>\n<h3>WORLDWIDE TRANSFERS AND PROCESSING OF PERSONAL INFORMATION AND CONSENT</h3>\n<p>All Personal Information that we collect through the Services is transferred to, and accessed from, jurisdictions, including the United States where Alpha Entertainment LLC has its headquarters.</p>\n<h3>YOUR CONSENT DECLARATION</h3>\n<p>By accepting this Privacy Policy, you consent to having your Personal Information transferred to, and accessed from, any location worldwide, including the United States for the purpose of providing the Services. You also consent to having your Personal Information processed and maintained in any location worldwide, including the United States for these purposes. You acknowledge that other jurisdictions may have laws that are different than the laws of your home country.</p>\n<p>For visitors to our Services who are based within the European Union, this will involve the processing of your Personal Information outside of the European Economic Area, (the “EEA”). If you do not wish your Personal Information to leave the European Economic Area, or your home country, please do not provide your Personal Information via the Services. If you have already provided your Personal Information, and you require us to stop processing your Personal Information, please contact us at info@xfl.com. If you provide your information you are aware that certain governmental authorities may have access to your Personal Information stored in the United States in accordance with your consent. The legal protections and other rights available to those affected in the event of such access by governmental authorities may be different compared to the protection provided in the EEA countries and may not entirely reflect standards imposed under European law. This includes the fact that governmental authorities may request access to your Personal Information without allowing us to inform you of such access, and that such requests for (and grants of) access may not be subject to equal limitations with regard to necessity and purpose as would be in effect under European law. Furthermore, governmental authorities may subject your Personal Information to further processing and such further processing may not be subject to equal limitations with regard to necessity and purpose as would be in effect under European law. Finally, you are aware that governmental authorities in the United States may not be subject to the same types or degree of public control by other authorities or courts as present under European law.</p>\n<h3>HOW WE USE YOUR INFORMATION</h3>\n<p>We limit the manner in which your Personal and Payment Information is used. We will use the Personal and Payment Information you provide only in a manner that is consistent with this Privacy Policy. If we obtain Personal or Payment Information from a third party, such as a business partner, our use of that information is also governed by this Privacy Policy. We use Personal and Payment Information for purposes such as: providing you the products and services you want; administering or enforcing transactions you have requested; protecting your accounts from fraud, unauthorized access, or identity theft; verifying your identity in connection with transactions you have requested; managing our business and protecting our interests; and as set out in our Terms of Use. We may also use Personal Information (but not Payment Information) to allow users of the Services to use a single set of credentials to access the Services, better understand and serve the needs of our community, and to provide news and information to you and community members on our new content, products, services, and features and/or our Services including, without limitation, via direct e-mail. We may use the Personal Information and other information we collect from you to send you marketing emails and other offers we believe may interest you. For example, if you leave our Website without purchasing items that you have placed in your shopping cart, we may send you an email reminding you about your saved items. Where permitted by (and in compliance with) laws of your jurisdiction (including laws requiring your consent to third party marketing uses of your Personal information), we may also permit select third parties to provide you with information about goods or services which we feel may interest you, via direct e-mail or otherwise.</p>\n<p>We may share Personal and Payment Information with our service providers to assist us with any of the purposes set forth above (which, for example, might include disclosures to attorneys, accountants, auditors, credit bureaus, data processors, payment processors, and technical systems consultants) to the extent necessary or appropriate for them to perform their services to us. In that connection, we may report information about your account(s) to credit bureaus and/or consumer reporting agencies. By way of example, if you order a product or service from us or register for one of our contests, promotions, or interactive services, we may share Personal Information with other service providers, suppliers and other third parties (for example, sweepstakes sponsors or delivery services) that assist us in operating the websites or providing the products or services.</p>\n<p>We may share Personal and Payment Information in the event that (i) we sell or buy any business or assets, in which case we may disclose your personal data to the prospective seller or buyer of such business or assets, or (ii) if we or substantially all of our assets are acquired by a third party, in which case personal data held will be one of the transferred assets.</p>\n<p>We do not share your Personal Information to third parties except as described in this Privacy Policy or as permitted under applicable law.</p>\n<p>Please note that we will release your Personal or Payment Information if required to do so by law, search warrant, subpoena, court order or other legal process. We may also disclose your Personal or Payment Information if we have a good faith belief that such disclosure is reasonably necessary to detect or prevent fraud or to protect our rights, property, health or personal safety or those of our employees, our third-party licensors, customers or the public. We may also disclose your Personal or Payment Information if you or your legal representative authorizes us to do so, or if it is necessary to perform credit checks or collect or report debts owed to us.</p>\n<h3>LINKS TO THIRD PARTY WEBSITES/MOBILE APPLICATIONS</h3>\n<p>Our Services contain or may contain certain hyperlinks to other third-party websites or mobile applications, some of which may display our logos or other content. These websites and mobile applications may have privacy policies; however, all of these websites, mobile applications and their privacy policies are independent of our Websites or this Privacy Policy. We are not responsible for compliance with other websites' or mobile applications' privacy policies or data collection practices. You should review these privacy policies carefully before providing any Personal Information to these websites or mobile applications.</p>\n<h3>LIMITATIONS ON USE OF PERSONAL INFORMATION</h3>\n<p>We will use or retain your Personal Information only in accordance with the terms of this Privacy Policy or as allowed by applicable law. In general, we strive to keep Personal Information only for so long as is needed to fulfill your requests, support Single Sign-On and the services you have requested, process your orders, or comply with the law, although we reserve the right to keep it for a longer period of time, if necessary.</p>\n<h3>SECURITY OF PERSONAL INFORMATION</h3>\n<p>We take what we believe to be appropriate physical, administrative and technical precautions in an effort to create security for your Personal Information, including the use of Transport Layer Security technology to help protect the transmission of Payment Information.</p>\n<h3>ACCESSING, CORRECTING, UPDATING, AND DELETING PERSONAL INFORMATION</h3>\n<p>If you would like to know what Personal Information we have concerning you, send an e-mail to <a href=\"https://info@xfl.com\">info@xfl.com</a>. We will be in contact with you (by mail or otherwise) to verify your identity and provide you the information you request. We will respond within 30 days of your request for access to your Personal Information. In some cases, we may not be able to remove your Personal Information, in which case we will let you know if we are unable to do so and why. Even if we are able to make your content no longer visible, this does not ensure complete or comprehensive removal of your content or personal information from the Internet as third parties may retain screen shots and/or share your video on other websites.</p>\n<p>We may try to translate our Website into various languages to help visitors understand the Terms and this Policy, but the English version of those documents is the binding version and we do not guarantee the translations. You are responsible for obtaining assistance if any is needed to understand the English version and for compliance with the laws of your country.</p>\n<h3>THIRD PARTY SERVICES WE MAY USE</h3>\n<p>We use third-party systems and services for a variety of purposes (collectively, “Third Party Services”). These third parties may have their own terms of use and privacy policies, which may apply to you.</p>\n<h3>THIRD PARTY ADVERTISING SERVICES AND ADVERTISEMENTS</h3>\n<p>Ads appearing on our Websites may be delivered to you by DoubleClick, or by other third-party advertising companies. Information about your visits to our Websites and third-party websites, such as number of times you have viewed an ad, date/time at which the ads were shown, the advertisers' cookies (browser or Flash) or other technologies, and the IP address of the computer used to serve ads to you on our Websites. We do not have access to the cookies that may be placed by our third-party advertising companies. We share website usage information about visitors to our Websites with these companies for our purposes, and for their purposes, which include – for example – managing and targeting advertisements, measuring their effectiveness, and for market research analysis. For these purposes, we and third-party advertising companies we use, may note the pages you visit on our sites. For more information about DoubleClick, please see <a href=\"https://www.google.com/doubleclick/\">www.google.com/doubleclick/</a> and <a href=\"https://www.google.com/intl/en/policies/privacy/\">www.google.com/intl/en/policies/privacy/</a>\nYou may be able to opt out of some of the cookies used by Third Party Services by using the options available at <a href=\"https://www.networkadvertising.org/choices/%3E\">www.networkadvertising.org/choices/</a>, although we do not guarantee that such elections will work as desired.</p>\n<p>We use Third-Party Services to help us analyze what you and others do at our Website and to do everything else that we may lawfully do with Personal Information or other information. That data tends to be stored on the third party’s servers and analyzed to provide reports and information to us. An example would be companies that provide data analytic services to us such as Google Analytics.</p>\n<p>We use Google Analytics, which uses cookies and similar technologies to collect and analyze information about use of the Website and report on activities and trends. This service may also collect information regarding the use of other websites, apps and online resources. You can learn about Google’s practices by going to <a href=\"https://www.google.com/policies/privacy/partners/\">www.google.com/policies/privacy/partners/</a>, and opt out of them by downloading the Google Analytics opt-out browser add-on, available at <a href=\"https://tools.google.com/dlpage/gaoptout\">tools.google.com/dlpage/gaoptout</a>.</p>\n<p>We also use Third-Party Services to help us track Website visitors. Third-Party Services may use Technologies to do this. The Third-Party Services may do this for our benefit, or for the benefit of third parties. For example, we use Google’s DoubleClick service. For more information about the privacy practices associated with DoubleClick, please visit <a href=\"https://www.google.com/intl/en/policies/\">www.google.com/intl/en/policies/</a>. </p>\n<p>Third-Party Services will change from time to time and we may update this Policy. This Privacy Policy does not address, and we are not responsible for, the privacy, information or other practices of any third parties, including any third party operating any site or service to which the Website link. The inclusion of a link on the Website does not imply endorsement of the linked site or service by us or by our affiliates.</p>\n<p>California Civil Code Section 1798.83 permits California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an email to <a href=\"https://www.google.com/intl/en/policies/\">www.google.com/intl/en/policies/</a>or write us at CA Privacy Rights, XFL 1266 East Main St., Stamford, CT 06902.</p>\n<h3>WHAT ABOUT THE SECURITY OF YOUR PERSONAL INFORMATION?</h3>\n<p>We seek to use organizational, technical and administrative measures to protect Personal Information within our organization. Unfortunately, no data transmission or storage system can be guaranteed to be 100% secure. WE DO NOT GUARANTEE THE SECURITY OF PERSONAL INFORMATION, WE PROVIDE THE SECURITY AS IS, AND DISCLAIM ANY (IF ANY) IMPLIED WARRANTIES, DUTIES OR CONDITIONS.</p>\n<p>Do not send sensitive information to us via email. It is your sole responsibility to use the appropriate level of care whenever you communicate with us. If you have reason to believe that your interaction with us is no longer secure (for example, if you feel that the security of your account has been compromised), please immediately notify us at <a href=\"https://info@xfl.com\">info@xfl.com</a>.</p>\n<p>XFL hereby disclaims, as far as permitted by local laws, any liability for itself and its affiliates and contractors for any Personal Information we collect that is lost, misused, illegally accessed, disclosed, altered or destroyed or not timely delivered to the Website.</p>\n<h3>NOTICE OF SERCURITY BREACH</h3>\n<p>If we or any of our service providers are required to provide notice of unauthorized access to, use of, or other disclosure of Personal Information about you, you agree that to the extent allowed under applicable law, we (or they) may do so voluntarily or when required by posting notice on the Website, sending notice to an e-mail or other “e” address we have for you (or that you have authorized for other communications) or by any other method allowed by law or contract, in our (or their) sole discretion.</p>\n<h3>CANDIDATE PRIVACY POLICY - COLLECTION OF PERSONAL INFORMATION FOR CANDIDATE RECRUITMENT</h3>\n<p>Below are examples of types of Personal Information we may collect directly from you. Much of this is part of your XFL employment application. Any information you submit through the Website must be true, complete and not misleading. Submitting inaccurate, incomplete, or misleading information may lead to a rejection of your application during the application process or disciplinary action including immediate termination of employment. In addition, it is your responsibility to ensure that information you submit does not violate any third party’s rights.</p>\n<p>Examples include, Contact Personal Information (such as your name, postal and email address, home and cell phone numbers); Qualification Personal Information to help us determine if you meet our employment criteria (such as your professional and other work-related license, permits and certifications held); Personal Information that you provide, such as Personal Information in a resume that you provide or in other communications from you; and/orPersonal Information about others such as the name of a reference for you or Personal Information about third parties that might be in a photo or video you send us. By submitting of a third-party’s Personal Information, you certify that you have obtained their permission to do so and the third-party’s consent to this Policy. Do not supply third-party Personal Information if you are not authorized to do so. Except where such information is legally required, we ask that you avoid submitting Personal Information that may be sensitive such as race, color, sex, gender identity, sexual orientation, nationality, national origin, ethnic origin, religion, beliefs or creed, age, disability, marital status, veteran status, and/or genetic information. For applicants in the EU, we also ask that you not submit trade union membership information. To the extent the Personal Information you provide contains details of your: racial or ethnic origin; political opinions or beliefs; religious beliefs; membership in a trade union or political party; physical or mental health or condition; sexual orientation; commission (or alleged commission) of an offence or related proceedings; job evaluations or educational records, you expressly authorize XFL to handle such details for the purposes of your job application, post application Personal Information. If we contact you after application submission, we’ll tell you about the next step and will collect additional Personal Information. For example, if we schedule a personal interview, we might collect travel Personal Information. Later steps involve additional Personal Information, e.g., all prospective XFL employees are required to submit to a background search prior to joining XFL. </p>\n<h3>LAW APPLICABLE TO CANDIDATES</h3>\n<p>We are located in, and the Site is operated from, the United States of America. If you are requested to audition with us, you will do that at our U.S. training facility. Accordingly, any Personal Information you submit to the Careers Site will be collected in the United States and will be subject to U.S. laws. Your Personal Information also may be stored and processed in any country where we have facilities or in which we engage service providers, and by using the Site you consent to the transfer of information to countries outside of your country of residence, including the United States, which may have data protection rules that are different from those of your country. However, if we share your Personal Information with an affiliate located in another country in its capacity as a potential employer, the affiliate will handle your Personal Information in accordance with this Policy. Any hiring or other employment-related decisions will be made by the hiring affiliate in accordance with the laws of the country where the job will be located.</p>\n<h3>METHODS OF COLLECTING PERSONAL INFORMATION OF CANDIDATES</h3>\n<p>Through the Site: We collect your Personal Information when you submit an application through the Site or send us a request for more information. From other people or records such as personal and employer references, public records and other publicly available sources (including but not limited to lawfully accessible social networks), and from service providers (e.g., in later stages of the employment process, service providers such as consumer reporting agencies will do background checks as permitted by applicable law). From physical facilities. We might also collect or receive Personal Information from technologies other than the Site. For example, if you interview at a physical facility, you will supply Personal Information in order to gain access and your image might be captured on cameras (internal or external). </p>\n<h3>USE AND DISCLOSURE OF PERSONAL INFORMATION OF CANDIDATES</h3>\n<p>We will use or Disclose collected Personal Information in connection with your Alpha Entertainment LLC Careers application and for all purposes described in this Policy or inherent in finding, investigating, engaging using, terminating and otherwise dealing with employees in general and each potential or retained employee. This includes Disclosures relating to our existing and future business missions, operations, obligations and rights, and also engaging in the activities (and related activities) for which we collect the Personal Information. For example (without limitation), we may Use and/or Disclose Personal Information for the following purposes:</p>\n<p>To process your application; to assess your capabilities and qualifications for a job; to conduct reference checks; to respond to your inquiries and fulfill your requests, such as to send you related information; to send administrative information to you, for example, information regarding the Site and changes to our terms, conditions and policies. to our affiliates for the purposes described in this Privacy Policy. to third party service providers that provide services such as hosting and operating the Site, recruiting assistance, background check processing, and similar services; to personalize your experience on the Site; for security, anti-fraud, authentication and verification purposes, including (without limitation) searching public records or publicly available information (such as information on the Internet that the public can see); to Third Party Services (see “What Third Party Services may we use”); to a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer or other disposition of all or any portion of our business, assets or stock (including in connection with any bankruptcy or similar proceedings); as we believe to be necessary or appropriate: (a) under applicable law, which may include laws outside your country of residence; (b) to respond to requests from courts, law enforcement agencies, regulatory agencies, and other public and government authorities, which may include such authorities outside your country of residence; (d) to enforce our terms and conditions; and (e) to protect our rights, privacy, safety or property, and/or that of our affiliates, you or others. for other purposes that are not in this Policy but that are indicated in connection with collection of the Personal Information (e.g., such as in a consent form provided before doing a doing a background check or in any contract for your services if we make an employment offer). Subject to applicable law, we reserve the right to make all lawful uses of Personal Information worldwide. The information about you will be added to our international candidate database and may be used to consider you for opportunities at Alpha Entertainment and its affiliates other than the one(s) for which you apply. If you do not wish us to do this, please email info@alphaentllc.com. If we hire you, Personal Information we collect in connection with your application may be incorporated into our human resources system and may be used to manage the new-hire process; any such information may become part of your employee file and may be used for other employment-related purposes.</p>\n<h3>HOW CAN A CANDIDATE ACCESS, CHANGE, OR SUPPRESS YOUR PERSONAL INFORMATION?</h3>\n<p>If you register on the Website and want to update, correct or delete Personal Information that we hold about you, you may use the Website functionality that lets you review and edit your entries. The updated profile will be used as the default the next time you apply for a job using your account online. To change Personal Information that you have already submitted for consideration for a specific position, please update your profile and resubmit your application for that position. We encourage you to promptly update your Personal Information if it changes or is inaccurate. You can and should update your contact information so that we can reach you.</p>\n<p>For other changes, you may request access to Personal Information we collect, or its modification or suppression, where permitted by applicable law. You may make a request for us to update eligible Personal Information by writing us at info@xfl.com. If applicable law requires us to accept requests by other means, please email that address to learn about them. We will respond to your request within a reasonable timeframe.</p>\n<p>In your request, please make clear what Personal Information you would like to access or have changed, whether you would like to have Personal Information that you have provided to us suppressed from our database or otherwise let us know what limitations you would like to put on our use of your Personal Information. For your protection, we may only implement requests with respect to the information associated with the particular email address that you use to send us your request, and we may need to verify your identity before implementing your request. We will try to comply with your request as soon as reasonably practicable. Please note that certain Personal Information may be exempt from such access, correction, or suppression rights pursuant to local data protection laws.</p>\n<p>Currently, we do not charge for responding to such requests, but reserve the right to do so. If we have a duty to require third parties to delete or cease using Person Information, you agree that we may satisfy it by sending them notice to do so.</p>\n<h3>HOW LONG DO WE KEEP CANDIDATE PERSONAL INFORMATION?</h3>\n<p>We will retain Personal Information for the period necessary to fulfill the purposes outlined in this Policy unless a longer retention period is required or permitted by law. We may also retain your information for the purpose of considering whether your skills are suitable for other opportunities. If you do not wish us to do this, please email us at please email us at <a href=\"https://info@xfl.com\">info@xfl.com</a>. We may remove Personal Information for inactive accounts from our database, subject to any applicable legal or regulatory obligations. Furthermore, Alpha Entertainment LLC may delete Personal Information about you (including your CV/résumé) from our database at any time and without providing any reason. Therefore, please retain your own copy of the Personal Information provided to us.</p>\n<h3>DIVERSITY</h3>\n<p>Alpha Entertainment LLC is an equal opportunity employer, which means we offer equal treatment to all applicants. Alpha Entertainment LLC does not discriminate, either directly or indirectly, on the grounds of race, color, sex, gender identity, sexual orientation, nationality, national origin, ethnic origin, religion, beliefs or creed, age, disability, marital status, veteran status or genetic information in any area of recruitment. In some countries we ask for information on the ethnic origin, gender and disability of our applicants for the purpose of monitoring equal opportunity. If you have a disability and would like to indicate as part of your application any relevant effects of your disability and any adjustment which you consider should reasonably be made to the process to assist your application, please do so in the relevant field during the application process.</p>\n<h3>WHAT ABOUT CURRENT EMPLOYEES?</h3>\n<p>If you currently work for XFL or one of our affiliates, you must be eligible to apply for a different position within Alpha Entertainment to use the Site. If you accept such a position, your benefits programs and Human Resources policies may change. Please consult with the HR manager for the new position concerning application eligibility, benefit programs, and HR policies applicable to that position.</p>\n<h3>EMPLOYMENT OF MINOR CHILDREN</h3>\n<p>This Website is not directed to individuals under the age of 18, and we and we request that minors under the age of 18 do not provide Personal Information through the Website. We do not accept applications from minors. XFL applicants must be over the age at which they may enter into a legally binding contract with us under the law of any state or jurisdiction of which they are a citizen.</p>\n<h3>IDENTITY THEFT</h3>\n<p>If you believe you are a victim of identity theft, you might be entitled by law to request certain information from us. You can do this by writing to us at the address below. If we receive a request, we will then explain what information we require in order to respond. Once we have all of the required information, we will supply, without charge, any information that we then have which we are legally required to provide (subject to applicable law, and reserving all rights and defenses).</p>\n<p>The Website is not intended for distribution to, or use by, any person or entity in any jurisdiction or country where such distribution or use would be contrary to local law or regulation.</p>\n<h3>LEGAL PROCESS AND RELATED DISCLOSURES</h3>\n<p>By “legal process” we mean things that we might have to comply with by law. Examples include subpoenas, warrants, identity theft requests,  investigative demands (from law enforcement, regulators or others), or national or international security letters, demands, etc. We will comply as required by law. We also reserve the right voluntarily to cooperate with the requesting party or to comply if we think that may help protect someone (including you, us or others) or some property (of ours, yours, or others).</p>\n<p>Sometimes the law will preclude us from telling you about the legal process. In other circumstances we might be allowed to tell you, but it might not be practical or inadvisable to do so. We will determine in our sole discretion whether to make an allowed contact (e.g., we might give you notice of a subpoena so that you can go to court and obtain an order allowing us not comply -- but we might not make contact if there is concern that such might facilitate potential harm). You agree that we may do all of the foregoing.</p>\n<h3>CHANGES TO THIS PRIVACY POLICY</h3>\n<p>We reserve the right to change this Privacy Policy at any time. If we change our Privacy Policy, we will post those changes here and we will change the \"Updated\" date at the top of this page. If we make any material changes, we will notify you by e-mail (sent to the e-mail address specified in your account) or by means of a prominent notice on this Website prior to the change becoming effective. We encourage you to visit this area frequently to stay informed.</p>\n<h3>CONTACT US</h3>\n<p>If you have any comments or questions about this Privacy Policy, please send an e-mail to <a href=\"https://info@xfl.com\">info@xfl.com</a>.  You may also contact at us by postal mail at: XFL, 1266 East Main St., Stamford, CT 06902</p>"}}}}]},"termsModal":{"edges":[{"node":{"label":"terms","title":"Terms and Conditions","content":{"childMarkdownRemark":{"html":"<p>Updated as of November 1, 2018.</p>\n<p>These Terms and Conditions of Use (“Terms of Use”) contain disclaimers of warranties, disclaimers of liability, and a binding arbitration clause and class action waiver.  Please read them carefully.</p>\n<h3>GENERAL</h3>\n<p>These Terms of Use apply to this website, related Alpha Entertainment LLC websites, and mobile applications (each a “Website”), and services that link to this policy (collectively, the “Services”) unless we have posted special terms of use to a particular website or with respect to a particular service. In that case, those special terms of use apply to that website or service to the extent that they are different from these Terms of Use. Services are provided by or on behalf of Alpha Entertainment LLC or its affiliates or subsidiaries (collectively \"Company,\" “we,” “us,” “XFL”). By using the Services, you signify your agreement to these terms and conditions of these Terms of Use. If you do not agree to these Terms of Use, please do not use the Services.</p>\n<p>Please note that these Terms of Use contain capitalized words or phrases. These words and phrases are defined terms. Their definitions are found either in our Privacy Policy or in these Terms of Use. To help you use our Privacy Policy and our Terms of Use we have made some words, phrases and headings into hyperlinks. These words, phrases and headings have color highlighting.</p>\n<p>These Terms of Use apply to you whether you are a \"Visitor\" (which means that you are simply visiting a Website) or a \"Registered Fan\" (which means that you have registered to participate in online activities or paid services). The term \"User\" refers to both a Visitor and a Registered Fan. Registered Fans are also referred to simply as \"Fans.\" The term \"Membership\" refers to a Registered Fan's account and ability to post to and participate in activities and services hosted on a Website. If you wish to become a Registered Fan, you must read these Terms of Use and indicate your agreement with these Terms of Use and with any other instructions or requirements that may be part of a registration process.</p>\n<p><strong>PLEASE NOTE</strong>: Eligibility. Membership is void where prohibited. Fans may not register with the Services unless: (a) all registration information you submit is accurate, current and complete; (b) you agree to maintain the accuracy of such information; (c) you are 13 years of age or older; and (d) your use of the Services does not violate any applicable law or regulation. Participation in the Services includes, but is not limited to, postings to or other forms of participation with forums, blogs, groups, comments, chats, or the submission of photos, videos or other content (\"Participation\"). Any content generated by a User involving the use of any functionality of a Website is referred to as \"User-Generated Content.\"</p>\n<p>Any User-Generated Content may be deleted and your registration may be cancelled without warning, if we believe that you are under 13 years of age, if we believe that you are under 18 years of age and you represent yourself as 18 or older, or if we believe you are over 18 and represent yourself as under 18. You may not engage in any form of Participation on behalf of another person and if we believe you have, we reserve the right to remove it.</p>\n<p>We may change these Terms of Use at any time. We suggest that you review these Terms of Use periodically for changes. Your use of the Services after the posting of changes to these Terms of Use will mean you accept the changes. Where, however any change to these Terms of Use is a material change (i.e. not one which is merely a small or technical change which does not affect you in any material way), we will post a notice or we will notify you of the relevant change(s) by email, using the email address you provided to us at registration. Your continued use of the Services after the changes come into effect will mean you accept the changes. If a material change to these Terms of Use needs to be made more quickly for security, legal or regulatory reasons, we will give you as much notice as we are reasonably able to give you. The most up-to-date version of these Terms of Use will always be available on our Website and when we notify you that the Terms of Use are changing we recommend that you print the latest version for your records.</p>\n<p>We may also offer other services from time to time that are governed by different terms and conditions of use. You will be provided with a copy of such terms and conditions of use prior to you contracting to receive such services. The Services are based in the United States. By using the Services and/or by submitting personal information to the Services, you consent to having your information transferred to the United States and being processed and maintained in the United States, subject to applicable U.S. laws. U.S. laws may be different than the law of your home country.</p>\n<h3>COPYRIGHT, OWNERSHIP AND RESTRICTIONS ON USE OF MATERIALS</h3>\n<p>All materials contained on the Services are the copyrighted property of the Company and its affiliates and/or our third-party licensors. All trademarks, service marks and trade names, as well as the names of our talent, are proprietary to the Company or its affiliates and are protected by state, federal and international trademark laws.</p>\n<p>The textual, photographic, video, audio and combined audiovisual programs and products resulting from our events, including the material contained in the Services, are protected under United States and international copyright laws as copyrighted works. No materials from the Services may be copied, reproduced, republished, uploaded, posted, transmitted or distributed in any way without our express written permission.</p>\n<p>Anyone who displays, reproduces, copies, creates derivative works or sells our textual, photographic, video or audiovisual programs for commercial or non-commercial purposes without our permission violates the copyright laws and is liable for copyright infringement. Any person who uses our marks or any similar marks in such a way that it dilutes the distinctive quality of the marks or that creates a likelihood of confusion with the marks for commercial purposes without our permission on goods or for services is liable for trademark infringement.</p>\n<p>If you download software or applications from the Services, the software or applications, including any files, images incorporated in or generated by the software or applications, and data and instructions accompanying the software or applications (collectively, the \"Software\") are licensed to you by us or our third-party licensors for your personal, non-commercial home use only. Any commercial or public use, including but not limited to use in any commercial premises and/or Software, is strictly prohibited.</p>\n<p>We do not transfer title to the Software to you, and we (or our third-party licensors) retain full and complete title to the Software and all intellectual property rights in the Software. You may not redistribute, sell, de-compile, reverse engineer, disassemble or otherwise reduce any of the Software to readable form.</p>\n<h3>SECURITY</h3>\n<p>We take the security of your personal information seriously. We take reasonable and appropriate steps to protect the security and integrity of your personal information, but please be aware that no solution for online and mobile security can be 100% effective. To the extent we collect payment information and/or shipping or billing information from you through the Services, we provide your payment information and billing and shipping information to service providers that help us to process and ship the goods or provide the services you purchase through this web site. Those vendors are solely responsible for how they use that information and any other information they independently acquire from you or about you. For more information on how we and our service providers and affiliates use and protect the personal information and payment information you may provide through this website, please review our Privacy Policy.</p>\n<p>To protect the security of your payment information in transmission, we employ reasonable technological measures including, where appropriate, Transport Layer Security technology (formerly referred to as secure socket layer technology (SSL) technology). When appropriate, we also may encrypt your payment information when we store your order and whenever we transfer that information to participating vendors or take other appropriate steps to protect the security of your personal information.</p>\n<p>Please keep in mind that whenever you provide personal information online - for example, via message boards or chat - that information can be collected and used by people you don't know. While we strive to protect your personal information, we cannot guarantee the security of any information you disclose online; you make such disclosures at your own risk. You may not use or attempt to use the Services to collect personal information about other persons or in any other manner that is inconsistent with another person's privacy or personal data protection rights.</p>\n<p>When you register as a Fan or when you register for certain Services, you will also be asked to choose a username, password or other identification information intended to restrict access to Participation and to otherwise protect your Membership from unauthorized access. You are entirely responsible for maintaining the confidentiality of your password and other identification information. You agree not to use the account, username, password or other identification information of another Fan at any time or to disclose your identification information to any third-party. You agree to notify us immediately if you suspect any unauthorized use of your account or access to your identification information. You are solely responsible for any and all use of your account. For the protection of Fans, we reserve the right to require or install revised account access procedures or applications at any time even though this may temporarily block access to certain parts of the Services.</p>\n<h3>MONITORING OF SERVICES</h3>\n<p>We expressly reserve the right to monitor any and all uses of the Services. However, we are under no obligation to do so, and we assume no responsibility or liability arising from our doing so or failure to do so. We assume no responsibility or liability arising from or relating to the content of any transmissions by third-parties to or through the Services or for any error, omission, defamatory or libelous statement, falsehood, obscenity, pornography, profanity or inaccuracy contained in any information transmitted by third-parties to or through any location on the Services.</p>\n<p>You may not post or transmit any unlawful, threatening, libelous, defamatory, obscene, inflammatory, pornographic or profane material or any material that could constitute or encourage conduct that would be considered a criminal offense, give rise to civil liability, or otherwise violate any law or any of these Terms of Use, or any other term or condition of use posted on the Services.</p>\n<p>Please note that we will release your personal or payment information if required to do so by law, or by search warrant, subpoena or court order or other legal process. We may also disclose your personal or payment information if we have a good faith belief that such disclosure is reasonably necessary to detect or prevent fraud and to protect the rights, property, health or personal safety of the Company, its employees, our third-party licensors, customers or the public. We may also disclose your personal or payment information if you or your legal representative authorizes us to do so or if necessary to perform credit checks or collect or report debts owed to us. Please see the Privacy Policy for more information about the circumstances under which we might release your personal or payment information.</p>\n<h3>SUBMISSIONS</h3>\n<p>At times, we may solicit from Visitors to the Websites information that includes but is not limited to, creative ideas, concepts, know-how, techniques, suggestions, ideas, artwork or other materials. Of course, Visitors to a Website may have the ability to submit information of this type to us even if we do not solicit it. Collectively this type of information, whether solicited by us or not, and whether or not posted to this Website or any other Website, is referred to as \"Submissions\".</p>\n<p>We do not want any video Submissions which involve stunts, tricks, or maneuvers that replicate, mimic, or portray in any fashion, the activities undertaken by our athletes or personnel. We would like to remind you that our talent are trained sports figures. You should never try to emulate what they do.</p>\n<p>By submitting any Submission, whether solicited by us or not, you are automatically granting us an ownership right and a perpetual, royalty-free, non-exclusive, unrestricted, worldwide and irrevocable right and license to sell, rent, transfer, sub-license, use, reproduce, modify, publish, translate, prepare derivative works based upon, distribute, perform, display or otherwise utilize such Submissions, in whole or in part, in any form, media or technology known or hereafter developed for any purpose, including, but not limited to, advertising and promotional purposes (collectively, \"Rights\").</p>\n<p>This grant of Rights means that all Submissions will be owned by us and may be used by us for any purpose, now or in the future, without any payment to, or further authorization by, you. All Submissions, whether solicited or unsolicited, shall become and remain the property of the Company. We also have the right, but not the obligation, to use your name or the name of any entity owned or controlled by you in connection with the broadcast, print, online or other use or publication of your Submission. We assume no responsibility for reviewing such Submissions and we will not incur any liability as a result of any similarities between your Submissions and future products, services or programs. In submitting a Submission to us, you represent that you have no reasonable basis to believe that the use of any such Submission by us would infringe upon the rights of any third-party.</p>\n<h3>THIRD-PARTY CONTENT</h3>\n<p>Please exercise discretion while browsing the Internet or using the Services. You should be aware that while using the Services you could be directed to other web sites by links and other features found on the Services. If you click on those links or other features, you may be visiting a web site or service that is not owned or operated by the Company and over which we have no control. For example, if you click on a banner advertisement, the click may take you to the web site of a company that is not related to us and over which we have no control. This includes links from advertisers, sponsors, content partners and other users that may use our logo(s) as part of a co-branding or affiliate agreement. These other web sites or services may collect data, solicit personal information and generate cookies on your computer in a manner different from our Services. These other web sites or services may also contain information that you may find inappropriate or offensive.</p>\n<p>We are not responsible in any way for the content or availability of information found on any web site or service owned by a third-party that may be linked to a Website by a hyperlink, whether such hyperlink is provided by us or by a third-party. By providing access to third-party web sites or advertisements, we are not endorsing the products or services provided by the owner or operator of such web sites. Consequently, we will not be liable or responsible for the accuracy, relevancy, reliability, copyright compliance, legality or decency of material contained in third-party web sites or services linked to the Services. We cannot ensure that you will be satisfied with any products or services you purchase from a third-party that links to or from the Services or that you purchase through third-party advertising or content on the Services. We do not make any representations or warranties as to the security of any information (including, without limitation, payment information and other personal information) you might be requested to give any third-party, and you hereby irrevocably waive any claim against us with respect to the products, services and content of third-party web sites, including third-party web sites or services accessible by links from the Services. We strongly encourage you to make whatever investigation you feel necessary or appropriate before proceeding with any online or offline transaction.</p>\n<h3>DISCLAIMERS</h3>\n<p>THE MATERIALS AND THE SERVICES ARE PROVIDED \"AS IS\" AND \"AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. WE DO NOT WARRANT THAT THE FUNCTIONS OR MATERIALS ON THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE DO NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OR THE RESULTS OF THE USE OF THE MATERIALS ON THE SERVICES IN TERMS OF THEIR CORRECTNESS, ACCURACY, RELIABILITY, OR OTHERWISE. WE ASSUME NO OBLIGATION TO ARCHIVE OR OTHERWISE PRESERVE ANY FAN PAGE. YOU ASSUME THE ENTIRE COST OF ALL NECESSARY MAINTENANCE, SERVICING, REPAIR, OR CORRECTION TO THE EQUIPMENT AND SOFTWARE YOU USE TO ACCESS THE SERVICES. IF APPLICABLE LAW DOES NOT ALLOW THE EXCLUSION OF SOME OR ALL OF THE ABOVE IMPLIED OR STATUTORY WARRANTIES, THE ABOVE EXCLUSIONS WILL APPLY TO YOU TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.</p>\n<p>We are not responsible for and make no warranties, express or implied, as to the User-Generated Content appearing on any Website or the Services, whether actually or apparently provided by Registered Fans or by any of the equipment or programming associated with or utilized in the Services. You post User-Generated Content to the Services at your own risk. Although we provide privacy settings that limit access to your profile, no security measures are perfect or impenetrable. We cannot control the actions of other Users with whom you may choose to share your User-Generated Content. We cannot and do not guarantee that your User-Generated Content will not be viewed by unauthorized persons. We are not responsible for circumvention of any privacy settings or security measures contained on the Services. Even after removal, copies of User-Generated Content may remain viewable in cached and archived pages or if other Users have copied or stored your User-Generated Content. User-Generated Content appearing on the Services does not necessarily reflect our opinions or policies. User-Generated Content may link to other websites. We are not responsible for the content, accuracy or opinions expressed on such websites, and such websites are not necessarily investigated, monitored or checked for accuracy or completeness. When you access these third-party sites, you do so at your own risk.</p>\n<h3>INDEMNIFICATION</h3>\n<p>To the extent we have assigned to you an account through the Services or you have obtained an account by registration as a Fan, you are entirely responsible for maintaining the confidentiality of your account and for all activities that occur under your account. You hereby indemnify, defend and hold the Company and our affiliates, officers, directors, owners, agents, information providers, licensors and licensees (collectively, the \"Indemnified Parties\") harmless from and against any and all liabilities and costs (including reasonable attorneys' fees) incurred by the Indemnified Parties in connection with any claim arising out of any breach by you of these Terms of Use (or claims arising from your account). You agree to use your best efforts to cooperate with us in the defense of any claim. We reserve the right, at our own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you.</p>\n<h3>LIMITATION OF LIABILITY</h3>\n<p>UNDER NO CIRCUMSTANCES, INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE, SHALL WE OR OUR AFFILIATES, EMPLOYEES, OFFICERS, DIRECTORS, OWNERS OR AGENTS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE SERVICES, INCLUDING THE MATERIALS OR FUNCTIONS ON THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IF APPLICABLE LAW DOES NOT ALLOW THE COMPLETE LIMITATION OR EXCLUSION OF LIABILITY OR INCIDENTAL OR CONSEQUENTIAL DAMAGES, THE ABOVE LIMITATIONS AND EXCLUSIONS WILL APPLY TO YOU TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW. IN NO EVENT SHALL THE TOTAL LIABILITY TO YOU OF THE COMPANY AND OUR AFFILIATES, EMPLOYEES, OFFICERS, DIRECTORS, OWNERS OR AGENTS FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION WHETHER IN CONTRACT, TORT (INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE, OR OTHERWISE) EXCEED THE AMOUNT PAID BY YOU TO THE COMPANY, IF ANY, FOR ACCESSING THE SERVICES.</p>\n<h3>COMMENTING ON A WEBSITE OR OTHER SERVICES</h3>\n<p>We have created opportunities on the Websites and Services for our fans so that they can have a safe and enjoyable place to interact with other fans, express themselves, and support their favorite talent. In order to maximize this opportunity for all fans, we require that fans agree to the following terms when they participate in commenting.</p>\n<p>A. Post only appropriate content</p>\n<p>What follows are examples of the kind of content that is illegal or prohibited to post anywhere on a Website or any Service. We reserve the right to investigate and take appropriate legal action against anyone who, in our sole discretion, violates this provision, including without limitation, removing the offending content and terminating the registration of such violators. Prohibited content includes, but is not limited to, content that:</p>\n<p>Harasses or advocates violence or harassment of another person;</p>\n<p>Publicly posts information that poses or creates a privacy or security risk to any person;</p>\n<p>Constitutes or promotes information that you know is false or misleading or promotes illegal activities or conduct that is abusive, threatening, obscene, defamatory or libelous;</p>\n<p>Constitutes or promotes an illegal or unauthorized copy of another person's copyrighted work;</p>\n<p>Is patently offensive and promotes racism, bigotry, hatred or physical harm of any kind against any group or individual;</p>\n<p>Contains nudity, excessive violence, or offensive subject matter or contains a link to an adult website; </p>\n<p>Solicits personal information from anyone under the age of 18;</p>\n<p>Promotes any criminal activity or enterprise;</p>\n<p>Solicits passwords or personal identifying information for commercial or unlawful purposes from other Users;</p>\n<p>Involves commercial activities or sales or contests or advertising, without our prior written consent; </p>\n<p>Includes a photograph or video of another person that you have posted without that person's consent;</p>\n<p>Imitates or purports to be a posting to a Website by anyone other than the person actually posting.</p>\n<p>B. Keep your Guard Up!</p>\n<p>You agree to choose carefully the User-Generated Content you post on or through the Services and that you provide to other Users. Although the Services may not include any form of Prohibited Content, as defined in Section A, some information, materials, products or services submitted to the Services by other Fans may, in whole or in part, be unauthorized, impermissible or otherwise violate this Agreement, and we assume no responsibility or liability for such material.</p>\n<p>Remember that although the use of screen names by Fans is not a violation of the Terms of Use, people are not always who they say they are. You should always be careful when communicating with people you do not know in the real world. And it is always risky to meet anyone in person whom you don't know through real world friends.</p>\n<p>Be cautious about posting and sharing personal information, especially information that could be used to identify you or locate you offline, such as your address or telephone number.</p>\n<p>You are solely responsible for your interactions with other Fans. We reserve the right, but have no obligation, to become involved in any way with disputes between you and other Fans.</p>\n<p>We cannot guarantee that any Participation or User-Generated Content on a Website was actually created by the individual or entity claiming authorship.</p>\n<p>C. Abide by All Laws</p>\n<p>You agree to use the Services, including all features and functionalities associated therewith, in accordance with all applicable laws, rules and regulations, or other restrictions on use of the service or content therein. Except as explicitly authorized in these Terms of Use, you agree not to archive, download (other than through caching necessary for personal use), reproduce, distribute, modify, display, perform, publish, license, create derivative works from, offer for sale, or use content and information contained on or obtained from or through the Services without our express written permission and that of any other necessary party. You also agree not to: circumvent, remove, alter, deactivate, degrade or thwart any of the content protections in the Services; use any robot, spider, scraper or other automated means to access the Services; decompile, reverse engineer or disassemble any software or other products or processes accessible through the Services; insert any code or product or manipulate the content of the Services in any way; or, use any data mining, data gathering or extraction method. In addition, you agree not to upload, post, e-mail or otherwise send or transmit any material designed to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment associated with the Services, including any software viruses or any other computer code, files or programs.</p>\n<p>You may not upload, embed, post, email, transmit or otherwise make available any material that infringes any copyright, patent, trademark, trade secret or other proprietary rights of any person or entity. We have the right to terminate the Membership of infringers. You represent and warrant that: (i) you own the User-Generated Content posted by you on or through the Services (or have the right to grant the appropriate license), and (ii) the posting of your User-Generated Content on or through the Services does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person or entity. You agree to pay for all royalties, fees, and any other monies owing any person or entity by reason of any User-Generated Content posted by you on or through the Services.</p>\n<p>We reserve the right, in our sole discretion, to reject, refuse to post or remove any User-Generated Content (including private messages) or to deny, restrict, suspend, or terminate your access to all or any part of any Services, including a Website, at any time, for any or no reason, with or without prior notice or explanation, and without liability. We expressly reserve the right to remove profiles from the Services and/or deny, restrict, suspend, or terminate your access to any Services, including a Website, if we determine in our sole discretion, that you have violated these Terms of Use or pose a threat to us and/or our fans.</p>\n<p>We assume no responsibility for monitoring Websites for inappropriate User-Generated Content or conduct. If at any time, we choose, in our sole discretion, to monitor User-Generated Content or conduct within Websites, we nonetheless assume no responsibility for the User-Generated Content or conduct, no obligation to modify or remove any inappropriate User-Generated Content, and no responsibility for the conduct of any Fan submitting such User-Generated Content.</p>\n<p>Illegal and/or unauthorized use of any Service, including collecting usernames, and/or email addresses of fans by electronic or other means for the purpose of sending unsolicited email or unauthorized framing of or linking to any Service, including any Website, or employing third-party promotional sites or software to promote a profile or posting on any Service for money, is prohibited. Commercial advertisements, affiliate links, and other forms of unauthorized solicitation may be removed from any Service including this one without notice or explanation and may result in termination of registration. We reserve the right to take appropriate legal action for any illegal or unauthorized use of any Website or any of the other Services.</p>\n<p>You are solely responsible for the photos, messages, notes, text, information, music, video and other content that you upload, publish or display (hereinafter, \"post\") to any Service or Website, or transmit to or share with other users. You may not post, transmit, or share content that you did not create or that you do not have permission to post.</p>\n<p>When you post content to any Service, this content is considered a Submission, as described above, and we have all of the rights and privileges described therein and elsewhere in these Terms of Use.</p>\n<h3>JURISDICTIONAL ISSUES</h3>\n<p>The Services are controlled and operated by or on our behalf and on behalf of our affiliates. We make no representation that materials or products offered on the Services are appropriate or available for use in any particular location. Those who choose to access the Services do so on their own initiative and are responsible for compliance with all applicable national and local laws. Software and products downloaded or purchased from the Services are further subject to United States export controls. No software or products offered on the Services may be downloaded, shipped or otherwise exported or re-exported (i) into (or to a national or resident of) Cuba, Libya, North Korea, Iran, Syria, or any other country to which the U.S. has embargoed goods; or (ii) to anyone on the U.S. Treasury Department's list of Specially Designated Nationals or the U.S. Commerce Department's Table of Deny Orders. By purchasing products or downloading or using the Software offered on the Services, you represent and warrant that you are not located in, under the control of, or a national or resident of any such country or on any such list.</p>\n<h3>TERMINATION</h3>\n<p>We may terminate your access to the Services immediately and without notice if in our sole discretion you fail to comply with any term or provision of these Terms of Use or any other term or condition of use posted on the Services. Upon termination of your use of the Services, you must cease use of the Services and destroy all materials obtained from the Services and all copies of such materials.</p>\n<p>We may terminate your status as a Registered Fan, delete any Website participation or any posting to any Website or other Service at any time, for any or no reason, with or without prior notice or explanation, without liability, and these Terms of Use will remain in effect. If you have any problems with the Services or your use of the Services or with these Terms of Use, your sole and exclusive remedy is to cease using the Services.</p>\n<h3>ARBITRATION OF DISPUTES; CLASS ACTION WAIVER</h3>\n<p>These Terms of Use shall be governed by and construed in accordance with the laws of the State of Connecticut and are subject to applicable copyright and intellectual property laws, without giving effect to any principles of conflicts of law. By using the Services, you waive any claims that may arise under the laws of other states, countries, territories, or jurisdictions.</p>\n<p>With respect to any and all disputes and claims arising out of or relating in any way to these Terms of Use or the Services (including without limitation the Privacy Policy), we and you agree to negotiate in good faith to achieve a mutually satisfactory resolution. If you and we do not resolve any dispute by informal negotiation, any other effort to resolve the dispute will be conducted by binding arbitration under the U.S. Federal Arbitration Act and federal arbitration laws, except as provided in this section.</p>\n<p>The arbitration will be done by the American Arbitration Association (AAA) under its Consumer Arbitration Rules. The AAA’s rules are available at www.adr.org or by calling 1-800-778-7879. Payment of filing, arbitrator, and administration fees will be governed by the AAA’s rules. We will reimburse those fees for claims totaling less than US$10,000, unless the arbitrator determines the claims are frivolous. In addition, we will not seek attorney’s fees and costs in arbitration unless it is determined by the arbitrator that the claims are frivolous.</p>\n<p>If your claim is worth US$10,000 or less, we agree that you may choose whether arbitration will be conducted by written submissions, telephone, or in person in the county where you live or at another mutually agreed upon location. If your claim exceeds US$10,000, the right to a hearing will be determined by the AAA rules. Any court with jurisdiction over the parties may enforce the arbitrator's award.</p>\n<p>Compared to lawsuits in court, arbitration is less formal. In arbitration, a neutral arbitrator is used instead of a judge or jury, and court review of the arbitration award is limited. An arbitrator has the ability to award the same relief and damages as a court.</p>\n<p>As the sole exception to this arbitration requirement, a User may pursue a claim in small claims court provided such claim is within that court’s jurisdiction and provided that the User proceeds only on an individual basis.</p>\n<p>If You choose to commence arbitration or file a small claims court action, you must first send a written notice to us by certified mail requesting arbitration or a small claims court action and describing your claim (“Notice”). Regardless of which party sends the Notice, it should describe the basis of the claim and set forth the specific relief sought. This letter must be addressed to: info@xfl.com. If we initiate arbitration, we will send a written Notice to the email address of the User used for access to the Services. If You and we do not reach an agreed upon resolution within 30 days of receiving notice, You or we have the right to begin an arbitration proceeding or file a claim in small claims court. A form Notice to initiate arbitration can be copied or downloaded at jud.ct.gov.</p>\n<p>For timeliness purposes, You and we agree to begin any arbitration or claim in small claims court within one year after a claim arises; otherwise, the claim is waived.</p>\n<p>You and we also agree that any proceedings to resolve or litigate any dispute will be conducted solely on an individual basis. Neither you nor we will seek to have any dispute heard as a class action or in any other proceeding in which either party acts or proposes to act in a representative capacity. No arbitration or proceeding will be combined with another without the prior written consent of all parties to all affected arbitrations or proceedings. We both also expressly waive the right to a trial by jury.</p>\n<p>To the extent arbitration is not applicable, You and we agree to submit to the exclusive jurisdiction of the state and federal courts (as applicable) located in Fairfield County of the State of Connecticut. You agree that we may bring suit in a court of competent jurisdiction in Connecticut to enjoin infringement or other misuse of intellectual property rights.</p>\n<h3>GENERAL PROVISIONS</h3>\n<p>If any provision of these Terms of Use shall be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from these Terms of Use and shall not affect the validity and enforceability of any remaining provisions of these Terms of Use. These Terms of Use constitute the entire agreement between us relating to your use of the Services. Our failure to exercise or enforce any right or provision of the Terms of Use shall not operate as a waiver of such right or provision. The section titles in the Terms of Use are for convenience only and have no legal or contractual effect.</p>\n<h3>DIGITAL MILLENNIUM COPYRIGHT ACT</h3>\n<p>If you believe your work has been copied and posted on or through these Services in a way that constitutes copyright infringement, please send our Copyright Agent a notification of claimed infringement with all of the following information:</p>\n<p>(a) identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works are covered by a single notification, a representative list of such works;</p>\n<p>(b) identification of the claimed infringing material and information reasonably sufficient to permit us to locate the material (providing the URL(s) of the claimed infringing material satisfies this requirement); </p>\n<p>(c) information reasonably sufficient to permit us to contact you, such as an address, telephone number, and, if available, an email address;</p>\n<p>(d) a statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law;</p>\n<p>(e) a statement by you, made under penalty of perjury, that the above information in your notification is accurate and that you are the copyright owner or are authorized to act on the copyright owner's behalf; and your physical or electronic signature.</p>\n<p>Our Copyright Agent can be reached at: <a href=\"https://CopyrightAgent@xfl.com\">CopyrightAgent@xfl.com</a> or\nCopyright Agent\nXFL\n1266 East Main St.\nStamford, CT 06902</p>\n<p>We have adopted a policy of terminating, in appropriate circumstances and at our sole discretion, the accounts of Fans who are deemed to be repeat infringers. We may also at our sole discretion limit access to the Services and/or terminate Memberships of any Users who infringe any intellectual property rights of others, whether or not there is any repeat infringement.</p>"}}}}]},"allContentfulTeam":{"edges":[{"node":{"urlSlug":"dallas"}},{"node":{"urlSlug":"houston"}},{"node":{"urlSlug":"los-angeles"}},{"node":{"urlSlug":"new-york"}},{"node":{"urlSlug":"st-louis"}},{"node":{"urlSlug":"seattle"}},{"node":{"urlSlug":"tampa-bay"}},{"node":{"urlSlug":"washington-dc"}}]}},"layoutContext":{}}

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(346);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(129);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _universalCookie = _interopRequireDefault(__webpack_require__(144));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _universalCookie.default;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Consumer = exports.Provider = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _universalCookie = _interopRequireDefault(__webpack_require__(144));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	var _a;
	
	var Provider = (_a = React.createContext(new _universalCookie.default()), _a.Provider),
	    Consumer = _a.Consumer;
	exports.Consumer = Consumer;
	exports.Provider = Provider;

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _universalCookie = _interopRequireDefault(__webpack_require__(144));
	
	var _CookiesContext = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	var __extends = void 0 && (void 0).__extends || function () {
	  var _extendStatics = function extendStatics(d, b) {
	    _extendStatics = Object.setPrototypeOf || {
	      __proto__: []
	    } instanceof Array && function (d, b) {
	      d.__proto__ = b;
	    } || function (d, b) {
	      for (var p in b) {
	        if (b.hasOwnProperty(p)) d[p] = b[p];
	      }
	    };
	
	    return _extendStatics(d, b);
	  };
	
	  return function (d, b) {
	    _extendStatics(d, b);
	
	    function __() {
	      this.constructor = d;
	    }
	
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	  };
	}();
	
	var CookiesProvider =
	/** @class */
	function (_super) {
	  __extends(CookiesProvider, _super);
	
	  function CookiesProvider(props) {
	    var _this = _super.call(this, props) || this;
	
	    if (props.cookies) {
	      _this.cookies = props.cookies;
	    } else {
	      _this.cookies = new _universalCookie.default();
	    }
	
	    return _this;
	  }
	
	  CookiesProvider.prototype.render = function () {
	    return React.createElement(_CookiesContext.Provider, {
	      value: this.cookies
	    }, this.props.children);
	  };
	
	  return CookiesProvider;
	}(React.Component);
	
	var _default = CookiesProvider;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Cookies", {
	  enumerable: true,
	  get: function get() {
	    return _Cookies.default;
	  }
	});
	Object.defineProperty(exports, "CookiesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _CookiesProvider.default;
	  }
	});
	Object.defineProperty(exports, "withCookies", {
	  enumerable: true,
	  get: function get() {
	    return _withCookies.default;
	  }
	});
	
	var _Cookies = _interopRequireDefault(__webpack_require__(668));
	
	var _CookiesProvider = _interopRequireDefault(__webpack_require__(669));
	
	var _withCookies = _interopRequireDefault(__webpack_require__(670));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = withCookies;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _CookiesContext = __webpack_require__(202);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	var __extends = void 0 && (void 0).__extends || function () {
	  var _extendStatics = function extendStatics(d, b) {
	    _extendStatics = Object.setPrototypeOf || {
	      __proto__: []
	    } instanceof Array && function (d, b) {
	      d.__proto__ = b;
	    } || function (d, b) {
	      for (var p in b) {
	        if (b.hasOwnProperty(p)) d[p] = b[p];
	      }
	    };
	
	    return _extendStatics(d, b);
	  };
	
	  return function (d, b) {
	    _extendStatics(d, b);
	
	    function __() {
	      this.constructor = d;
	    }
	
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	  };
	}();
	
	var __assign = void 0 && (void 0).__assign || function () {
	  __assign = Object.assign || function (t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	      s = arguments[i];
	
	      for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	      }
	    }
	
	    return t;
	  };
	
	  return __assign.apply(this, arguments);
	};
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// Only way to make function modules work with both TypeScript and Rollup
	var hoistStatics = __webpack_require__(127);
	
	function withCookies(WrapperComponent) {
	  // @ts-ignore
	  var name = WrapperComponent.displayName || WrapperComponent.name;
	
	  var CookieWrapper =
	  /** @class */
	  function (_super) {
	    __extends(CookieWrapper, _super);
	
	    function CookieWrapper() {
	      var _this = _super !== null && _super.apply(this, arguments) || this;
	
	      _this.onChange = function () {
	        // Make sure to update children with new values
	        _this.forceUpdate();
	      };
	
	      return _this;
	    }
	
	    CookieWrapper.prototype.listen = function (cookies) {
	      if (cookies !== this.cookies) {
	        this.unlisten();
	        this.cookies = cookies;
	        this.cookies.addChangeListener(this.onChange);
	      }
	    };
	
	    CookieWrapper.prototype.unlisten = function () {
	      if (this.cookies) {
	        this.cookies.removeChangeListener(this.onChange);
	      }
	    };
	
	    CookieWrapper.prototype.componentWillUnmount = function () {
	      this.unlisten();
	    };
	
	    CookieWrapper.prototype.render = function () {
	      var _this = this;
	
	      return React.createElement(_CookiesContext.Consumer, null, function (cookies) {
	        _this.listen(cookies);
	
	        var _a = _this.props,
	            forwardedRef = _a.forwardedRef,
	            restProps = __rest(_a, ["forwardedRef"]);
	
	        var allCookies = cookies.getAll();
	        return React.createElement(WrapperComponent, __assign({}, restProps, {
	          ref: forwardedRef,
	          cookies: cookies,
	          allCookies: allCookies
	        }));
	      });
	    };
	
	    CookieWrapper.displayName = "withCookies(" + name + ")";
	    CookieWrapper.WrapperComponent = WrapperComponent;
	    return CookieWrapper;
	  }(React.Component);
	
	  var CookieWrapperWithRef = React.forwardRef(function (props, ref) {
	    return React.createElement(CookieWrapper, __assign({}, props, {
	      forwardedRef: ref
	    }));
	  });
	  return hoistStatics(CookieWrapperWithRef, WrapperComponent, {
	    WrappedComponent: true
	  });
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var cookie = _interopRequireWildcard(__webpack_require__(165));
	
	var _utils = __webpack_require__(726);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	// We can't please Rollup and TypeScript at the same time
	// Only way to make both of them work
	var objectAssign = __webpack_require__(82);
	
	var Cookies =
	/** @class */
	function () {
	  function Cookies(cookies) {
	    this.changeListeners = [];
	    this.cookies = (0, _utils.parseCookies)(cookies);
	    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	  }
	
	  Cookies.prototype._updateBrowserValues = function () {
	    if (!this.HAS_DOCUMENT_COOKIE) {
	      return;
	    }
	
	    this.cookies = cookie.parse(document.cookie);
	  };
	
	  Cookies.prototype._emitChange = function (params) {
	    for (var i = 0; i < this.changeListeners.length; ++i) {
	      this.changeListeners[i](params);
	    }
	  };
	
	  Cookies.prototype.get = function (name, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    this._updateBrowserValues();
	
	    return (0, _utils.readCookie)(this.cookies[name], options);
	  };
	
	  Cookies.prototype.getAll = function (options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    this._updateBrowserValues();
	
	    var result = {};
	
	    for (var name_1 in this.cookies) {
	      result[name_1] = (0, _utils.readCookie)(this.cookies[name_1], options);
	    }
	
	    return result;
	  };
	
	  Cookies.prototype.set = function (name, value, options) {
	    var _a;
	
	    if (_typeof(value) === 'object') {
	      value = JSON.stringify(value);
	    }
	
	    this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));
	
	    if (this.HAS_DOCUMENT_COOKIE) {
	      document.cookie = cookie.serialize(name, value, options);
	    }
	
	    this._emitChange({
	      name: name,
	      value: value,
	      options: options
	    });
	  };
	
	  Cookies.prototype.remove = function (name, options) {
	    var finalOptions = options = objectAssign({}, options, {
	      expires: new Date(1970, 1, 1, 0, 0, 1),
	      maxAge: 0
	    });
	    this.cookies = objectAssign({}, this.cookies);
	    delete this.cookies[name];
	
	    if (this.HAS_DOCUMENT_COOKIE) {
	      document.cookie = cookie.serialize(name, '', finalOptions);
	    }
	
	    this._emitChange({
	      name: name,
	      value: undefined,
	      options: options
	    });
	  };
	
	  Cookies.prototype.addChangeListener = function (callback) {
	    this.changeListeners.push(callback);
	  };
	
	  Cookies.prototype.removeChangeListener = function (callback) {
	    var idx = this.changeListeners.indexOf(callback);
	
	    if (idx >= 0) {
	      this.changeListeners.splice(idx, 1);
	    }
	  };
	
	  return Cookies;
	}();
	
	var _default = Cookies;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _Cookies = _interopRequireDefault(__webpack_require__(725));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Cookies.default;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	exports.parseCookies = parseCookies;
	exports.isParsingCookie = isParsingCookie;
	exports.readCookie = readCookie;
	
	var cookie = _interopRequireWildcard(__webpack_require__(165));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function hasDocumentCookie() {
	  // Can we get/set cookies on document.cookie?
	  return (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}
	
	function parseCookies(cookies) {
	  if (typeof cookies === 'string') {
	    return cookie.parse(cookies);
	  } else if (_typeof(cookies) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  if (isParsingCookie(value, options.doNotParse)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {// At least we tried
	    }
	  }
	
	  return value;
	}

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _copyright = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright Component
	 * @param {object} params Incoming Params
	 * @returns {XML} A new copyright component
	 */
	var Copyright = function Copyright() {
	  return _react2.default.createElement(
	    _copyright.CopyrightText,
	    null,
	    'TM & \xA9 2019 XFL. All rights reserved.'
	  );
	};
	
	exports.default = Copyright;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _copyright = __webpack_require__(261);
	
	Object.defineProperty(exports, 'Copyright', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_copyright).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CopyrightText = undefined;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CopyrightText = /*#__PURE__*/exports.CopyrightText = _styledComponents2.default.p.withConfig({
	  componentId: 'sc-5bgwcb-0'
	})(['color:', ';', ';font-weight:400;letter-spacing:3px;font-size:12px;text-transform:uppercase;'], _theme.darkBlue, _theme.roboto);

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _copyright = __webpack_require__(262);
	
	var _footerItem = __webpack_require__(97);
	
	var _footerItem2 = _interopRequireDefault(_footerItem);
	
	var _footer = __webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	/**
	 * Footer Component
	 * @returns {XML} A rendered Footer
	 */
	var Footer = function Footer(_ref) {
	  var showModal = _ref.showModal,
	      teams = _ref.teams,
	      modals = _ref.modals;
	
	  var teamsLink = '';
	  if (teams && teams.edges && teams.edges.length > 0) {
	    teamsLink = '/teams/' + teams.edges[0].node.urlSlug;
	  }
	  return _react2.default.createElement(
	    _footer.FooterWrapper,
	    null,
	    _react2.default.createElement(
	      _footer.FooterRow,
	      null,
	      _react2.default.createElement(_footerItem2.default, { target: teamsLink, text: 'Teams', primary: true }),
	      _react2.default.createElement(_footerItem2.default, { target: '/football', text: 'Football', primary: true }),
	      _react2.default.createElement(_footerItem2.default, { target: '/tickets', text: 'Tickets', primary: true }),
	      _react2.default.createElement(_footerItem2.default, { target: 'https://www.teamworkonline.com/football-jobs/xfl/xfl-jobs', text: 'Careers', primary: true }),
	      _react2.default.createElement(_footerItem2.default, { target: '/news', text: 'News', primary: true }),
	      _react2.default.createElement(_footerItem2.default, { target: '/faq', text: 'FAQ', primary: true }),
	      _react2.default.createElement(_footerItem2.default, {
	        target: 'https://www.xflshop.com/' + '?utm_source=XFL&utm_medium=Dotcom&utm_term=top&utm_content=link&utm_campaign=nav',
	        text: 'Shop',
	        primary: true
	      })
	    ),
	    _react2.default.createElement(
	      _footer.FooterRow,
	      { className: 'footer-row--small' },
	      modals && modals.contactus && modals.contactus.content && _react2.default.createElement(_footerItem2.default, { text: 'Contact Us', overlay: 'contactus', show: showModal })
	    ),
	    _react2.default.createElement(
	      _footer.FooterRow,
	      { className: 'footer-row--small footer-row--light footer-row--top-gap' },
	      _react2.default.createElement(_footerItem2.default, { text: 'Terms & Conditions', target: '/termsandconditions', primary: true }),
	      _react2.default.createElement(_footerItem2.default, { text: 'Privacy Policy', target: '/privacypolicy', primary: true })
	    ),
	    _react2.default.createElement(
	      _footer.FooterRow,
	      null,
	      _react2.default.createElement(_copyright.Copyright, { parent: 'footer' })
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _footer = __webpack_require__(288);
	
	Object.defineProperty(exports, 'Footer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_footer).default;
	  }
	});
	
	var _footerItem = __webpack_require__(97);
	
	Object.defineProperty(exports, 'FooterItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_footerItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _menuItem = __webpack_require__(308);
	
	var _share = __webpack_require__(328);
	
	var _adaptive = __webpack_require__(8);
	
	var _header = __webpack_require__(293);
	
	var _gaEvent = __webpack_require__(98);
	
	var _gaEvent2 = _interopRequireDefault(_gaEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Header Component
	 */
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  /**
	   * Constructor
	   * @param {object} props incoming props
	   */
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggleMenu = _this.toggleMenu.bind(_this);
	    _this.navItemClick = _this.navItemClick.bind(_this);
	    _this.state = {
	      toggled: false,
	      tabletView: false
	    };
	    return _this;
	  }
	
	  /**
	   * Sets tablet state on mount
	   */
	
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    if ((0, _adaptive.isTablet)()) {
	      this.setState({ tabletView: true });
	    }
	  };
	
	  /**
	   * Send a google analytics event and do a toggle
	   * @param {string} destination Link destination
	   */
	
	
	  Header.prototype.navItemClick = function navItemClick(destination) {
	    (0, _gaEvent2.default)({
	      eventCategory: 'Nav',
	      eventAction: 'Click',
	      eventLabel: destination
	    });
	    this.toggleMenu();
	  };
	
	  /**
	   * Toggles the menu open or closed
	   */
	
	
	  Header.prototype.toggleMenu = function toggleMenu() {
	    var _state = this.state,
	        toggled = _state.toggled,
	        tabletView = _state.tabletView;
	
	    var newToggle = !toggled;
	    if (newToggle && tabletView) {
	      window.document.querySelector('html').setAttribute('class', 'locked');
	      window.document.querySelector('body').setAttribute('class', 'locked');
	    } else {
	      window.document.querySelector('html').setAttribute('class', '');
	      window.document.querySelector('body').setAttribute('class', '');
	    }
	    this.setState({
	      toggled: newToggle
	    });
	  };
	
	  /**
	   * Renders the component
	   * @returns {XML} A Header
	   */
	
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state2 = this.state,
	        toggled = _state2.toggled,
	        tabletView = _state2.tabletView;
	    var teams = this.props.teams;
	
	    var currentRoute = '';
	    var teamsLink = '';
	    if (typeof window !== 'undefined' && window.location) {
	      currentRoute = window.location.pathname;
	    }
	
	    if (teams && teams.edges && teams.edges.length > 0) {
	      teamsLink = '/teams/' + teams.edges[0].node.urlSlug;
	    }
	
	    return _react2.default.createElement(
	      _header.NavWrapper,
	      null,
	      _react2.default.createElement(
	        _header.Nav,
	        { className: 'nav' },
	        _react2.default.createElement(
	          _header.Logo,
	          { className: '', 'data-target': 'hero', to: '/', name: 'logo', title: 'XFL Logo', 'aria-label': 'Home Page Link' },
	          _react2.default.createElement('img', { className: 'nav__logo', src: '/images/XFL_LOGO.svg', alt: 'XFL Logo' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'nav__links ' + (toggled ? 'toggled' : '') },
	          _react2.default.createElement(
	            _header.LargeRow,
	            { className: 'nav_links-container' },
	            tabletView ? _react2.default.createElement(_menuItem.MenuItem, { exact: true, target: '/', text: 'Home', onClick: function onClick() {
	                return _this2.navItemClick('Home');
	              }, mobileOnly: true }) : '',
	            _react2.default.createElement(_menuItem.MenuItem, {
	              target: teamsLink,
	              active: currentRoute.indexOf('teams') > -1,
	              text: 'Teams',
	              onClick: function onClick() {
	                return _this2.navItemClick('Teams');
	              }
	            }),
	            _react2.default.createElement(_menuItem.MenuItem, { target: '/football', text: 'Football', onClick: function onClick() {
	                return _this2.navItemClick('Home');
	              } }),
	            _react2.default.createElement(_menuItem.MenuItem, { target: '/tickets', text: 'Tickets', onClick: function onClick() {
	                return _this2.navItemClick('Tickets');
	              } }),
	            _react2.default.createElement(_menuItem.MenuItem, { target: '/watch', text: 'Watch', onClick: function onClick() {
	                return _this2.navItemClick('Watch');
	              } }),
	            _react2.default.createElement(_menuItem.MenuItem, {
	              target: 'https://www.xflshop.com/' + '?utm_source=XFL&utm_medium=Dotcom&utm_term=top&utm_content=link&utm_campaign=nav',
	              text: 'Shop',
	              onClick: function onClick() {
	                return _this2.navItemClick('Shop');
	              }
	            }),
	            _react2.default.createElement(_menuItem.MenuItem, { target: '/news', text: 'News', onClick: function onClick() {
	                return _this2.navItemClick('News');
	              } }),
	            _react2.default.createElement(_menuItem.MenuItem, { target: '/faq', text: 'FAQ', onClick: function onClick() {
	                return _this2.navItemClick('FAQ');
	              } }),
	            _react2.default.createElement(_menuItem.MenuItem, {
	              target: 'https://www.teamworkonline.com/football-jobs/xfl/xfl-jobs',
	              text: 'Careers',
	              onClick: function onClick() {
	                return _this2.navItemClick('Careers');
	              }
	            }),
	            _react2.default.createElement(_share.ShareLink, { desktop: true })
	          )
	        ),
	        _react2.default.createElement(_menuItem.MenuIcon, { onClick: this.toggleMenu })
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _header = __webpack_require__(291);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_header).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LargeRow = exports.SmallRow = exports.Logo = exports.NavMobileLinks = exports.Nav = exports.NavWrapper = undefined;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__(5);
	
	var _breakpoints = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavWrapper = /*#__PURE__*/exports.NavWrapper = _styledComponents2.default.div.withConfig({
	  componentId: 'sc-7gj8c6-0'
	})(['min-height:93px;@media (max-width:', 'px){min-height:80px;}'], _breakpoints.tablet);
	
	var Nav = /*#__PURE__*/exports.Nav = _styledComponents2.default.nav.withConfig({
	  componentId: 'sc-7gj8c6-1'
	})(['background:white;display:flex;justify-content:space-between;padding:20px 0 20px 20px;width:100%;position:fixed;z-index:21;.nav__links{display:flex;align-items:center;background:white;.nav_links-container > .nav__link{padding:0 15px;}&.share-button{', ';}}.nav__link--active{&:after{display:none;}span{position:relative;&:after{content:\'\';position:absolute;width:calc(100% - 3px);height:4px;bottom:4px;left:0;background-color:', ';}}}.nav__link-text{border-bottom:none;color:#093a9a;', ';font-weight:500;letter-spacing:3px;font-size:13px;}.nav_links-container{display:flex;align-items:center;}@media (max-width:1028px){.nav__link-text{font-size:16px;}.nav_links-container{flex-direction:column;margin:0 auto;}.nav__link--active{&:after{display:none;}span{position:relative;&:after{content:\'\';position:absolute;width:100%;height:4px;bottom:-9px;left:0;background-color:', ';}}}}'], _theme.roboto, _theme.red, _theme.roboto, _theme.red);
	
	var NavMobileLinks = /*#__PURE__*/exports.NavMobileLinks = _styledComponents2.default.div.withConfig({
	  componentId: 'sc-7gj8c6-2'
	})(['.nav__mobile-links{box-shadow:none;}']);
	
	var Logo = /*#__PURE__*/exports.Logo = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	  componentId: 'sc-7gj8c6-3'
	})(['width:109px;height:48px;']);
	
	var SmallRow = /*#__PURE__*/exports.SmallRow = _styledComponents2.default.div.withConfig({
	  componentId: 'sc-7gj8c6-4'
	})(['', ' a{font-size:14px;}'], _theme.teko);
	
	var LargeRow = /*#__PURE__*/exports.LargeRow = _styledComponents2.default.div.withConfig({
	  componentId: 'sc-7gj8c6-5'
	})(['']);

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _menuIcon = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Menu Icon Component
	 * @param {object} props Incoming props
	 * @returns {XML} Menu Component
	 */
	var MenuIcon = function MenuIcon(props) {
	  return _react2.default.createElement(
	    _menuIcon.MenuToggle,
	    {
	      className: 'nav__links-toggle mobile-only',
	      onClick: function onClick() {
	        props.onClick();
	      },
	      onKeyDown: function onKeyDown(e) {
	        if (e.which === 13 || e.keyCode === 13) props.onClick();
	      },
	      role: 'button',
	      tabIndex: '0'
	    },
	    _react2.default.createElement(
	      'svg',
	      {
	        className: 'circle-svg',
	        xmlns: 'http://www.w3.org/2000/svg',
	        xmlnsXlink: 'http://www.w3.org/1999/xlink',
	        width: '58',
	        height: '58'
	      },
	      _react2.default.createElement('circle', { className: 'circle-svg__circle', r: '19', cx: '50%', cy: '50%', strokeDasharray: '1, 6' }),
	      _react2.default.createElement('circle', { className: 'circle-svg__circle circle-svg__circle--big', r: '27', cx: '50%', cy: '50%', strokeDasharray: '1, 3' })
	    ),
	    'Toggle Menu'
	  );
	};
	
	exports.default = MenuIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  target: _propTypes2.default.string,
	  exact: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  target: '',
	  exact: false
	};
	
	/**
	 * Menu Item
	 * @param {object} props Incoming Props
	 * @returns {XML} A Menu Item
	 */
	var MenuItem = function MenuItem(_ref) {
	  var target = _ref.target,
	      mobile = _ref.mobile,
	      text = _ref.text,
	      active = _ref.active,
	      onClick = _ref.onClick,
	      deeplink = _ref.deeplink,
	      exact = _ref.exact;
	
	  if (target.indexOf('http') > -1) {
	    return _react2.default.createElement(
	      'a',
	      {
	        className: 'nav__' + (mobile ? 'mobile-' : '') + 'link ' + (active ? 'nav__link--active' : ''),
	        'data-target': text,
	        href: target,
	        name: text,
	        'data-event': text,
	        'data-label': text,
	        'aria-label': text + ' Navigation Link',
	        target: '_blank',
	        rel: 'noopener noreferrer',
	        onClick: onClick
	      },
	      _react2.default.createElement(
	        'span',
	        { className: 'nav__link-text' },
	        text
	      )
	    );
	  }
	  if (deeplink) {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        strict: true,
	        className: 'nav__' + (mobile ? 'mobile-' : '') + 'link ' + (active ? 'nav__link--active' : ''),
	        'data-target': target,
	        to: '' + target,
	        name: target,
	        'data-event': text,
	        'data-label': target,
	        'aria-label': text + ' Navigation Link',
	        onClick: onClick,
	        exact: exact
	      },
	      _react2.default.createElement(
	        'span',
	        { className: 'nav__link-text' },
	        text
	      )
	    );
	  }
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    {
	      className: 'nav__' + (mobile ? 'mobile-' : '') + 'link ' + (active ? 'nav__link--active' : ''),
	      'data-target': target,
	      to: '' + target,
	      name: target,
	      'data-event': text,
	      'data-label': target,
	      'aria-label': text + ' Navigation Link',
	      activeClassName: 'nav__link--active',
	      onClick: onClick,
	      exact: exact
	    },
	    _react2.default.createElement(
	      'span',
	      { className: 'nav__link-text' },
	      text
	    )
	  );
	};
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports.default = MenuItem;
	module.exports = exports['default'];

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _menuItem = __webpack_require__(307);
	
	Object.defineProperty(exports, 'MenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_menuItem).default;
	  }
	});
	
	var _menuIcon = __webpack_require__(306);
	
	Object.defineProperty(exports, 'MenuIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_menuIcon).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MenuToggle = undefined;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuToggle = /*#__PURE__*/exports.MenuToggle = _styledComponents2.default.div.withConfig({
	  componentId: 'sc-1qx88k6-0'
	})(['&:before,&::after{background:', ';}&:after{box-shadow:0 -0.75rem 0 0 ', ';}'], _theme.blue, _theme.blue);

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(147);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(203);
	
	var _protection = __webpack_require__(322);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * News Component
	 */
	var Protection = function (_React$Component) {
	  _inherits(Protection, _React$Component);
	
	  /**
	   * gets cookie if there
	   * @param {object} props Incoming props
	   */
	  function Protection(props) {
	    _classCallCheck(this, Protection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var cookies = props.cookies;
	
	    _this.state = {
	      access: cookies.get('xaccess') || ''
	    };
	    return _this;
	  }
	
	  /**
	   * Triggers validation
	   */
	
	
	  Protection.prototype.componentDidMount = function componentDidMount() {
	    this.validateAuthCode({
	      onMount: true
	    });
	  };
	
	  /**
	   * Handles the code change for access
	   * @param {string} access Access
	   */
	
	
	  Protection.prototype.handleCodeChange = function handleCodeChange(access) {
	    this.setState({
	      access: access,
	      errorMsg: ''
	    });
	  };
	
	  /**
	   * Validates the auth code
	   * @param {props} param0 incoming props
	   */
	
	
	  Protection.prototype.validateAuthCode = function validateAuthCode(_ref) {
	    var _this2 = this;
	
	    var onMount = _ref.onMount;
	    var access = this.state.access;
	
	    var stateToSet = {
	      initialCall: true
	    };
	    _axios2.default.post('https://rpxug71l6h.execute-api.us-east-1.amazonaws.com/dev/authenticate', {
	      accessCode: access
	    }).then(function (response) {
	      if (response && response.data && response.data.hasAccess) {
	        var cookies = _this2.props.cookies;
	
	        cookies.set('xaccess', access);
	        stateToSet.grantEntry = true;
	      } else if (!onMount) {
	        stateToSet.errorMsg = 'Sorry, your code is invalid!';
	      }
	      _this2.setState(_extends({}, stateToSet));
	    }).catch(function () {
	      if (!onMount) {
	        stateToSet.errorMsg = 'Trouble proccess. Please try again.';
	        _this2.setState(_extends({}, stateToSet));
	      }
	    });
	  };
	
	  /**
	   * Renders an auth form for the user
	   * @returns {XML} Authoring form
	   */
	
	
	  Protection.prototype.renderAuthForm = function renderAuthForm() {
	    var _this3 = this;
	
	    var _state = this.state,
	        access = _state.access,
	        errorMsg = _state.errorMsg;
	
	    return _react2.default.createElement(
	      _protection.FormStyles,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement('img', { alt: 'XFL Logo', src: '/images/XFL_LOGO.svg' })
	          ),
	          _react2.default.createElement(
	            'form',
	            null,
	            _react2.default.createElement('input', {
	              type: 'text',
	              access: access,
	              onChange: function onChange(e) {
	                _this3.handleCodeChange(e.target.value);
	              },
	              placeholder: 'Access Code'
	            }),
	            _react2.default.createElement(
	              _protection.FormButton,
	              {
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this3.validateAuthCode({});
	                }
	              },
	              'Submit'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          errorMsg,
	          '&nbsp;'
	        )
	      )
	    );
	  };
	
	  /**
	   * Renders an AmbientVideo Component
	   * @returns {XML} AmbientVideo Component
	   */
	
	
	  Protection.prototype.render = function render() {
	    var children = this.props.children;
	    var _state2 = this.state,
	        grantEntry = _state2.grantEntry,
	        initialCall = _state2.initialCall;
	
	
	    if (grantEntry) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    }if (initialCall) {
	      return this.renderAuthForm();
	    }
	    return _react2.default.createElement('div', null);
	  };
	
	  return Protection;
	}(_react2.default.Component);
	
	exports.default = (0, _reactCookie.withCookies)(Protection);
	module.exports = exports['default'];

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _protection = __webpack_require__(320);
	
	Object.defineProperty(exports, 'Protection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_protection).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FormStyles = exports.FormButton = undefined;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _atoms = __webpack_require__(7);
	
	var _theme = __webpack_require__(5);
	
	var _breakpoints = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormButton = /*#__PURE__*/exports.FormButton = (0, _styledComponents2.default)(_atoms.BlueButton).withConfig({
	    componentId: 'sc-2k8a5j-0'
	})(['font-size:47px;display:inline-block;']);
	
	var FormStyles = /*#__PURE__*/exports.FormStyles = _styledComponents2.default.div.withConfig({
	    componentId: 'sc-2k8a5j-1'
	})(['overflow:hidden;.wrapper{margin:5em auto;padding:30px;width:350px;text-align:center;border:1px solid ', ';@media(max-width:', 'px){width:100%;padding:30px;border:none;}}.logo{text-align:center;padding-top:30px;img{display:inline-block;width:150px;}}input{display:block;padding:10px;margin:40px auto;padding:0 0 14px 0;width:100%;max-width:250px;height:54px;border-bottom:1px solid ', ';', ' font-size:38px;color:', ';text-align:center;&::placeholder{', ' font-size:38px;color:', ';}@media(max-width:', 'px){font-size:20px;height:auto;padding-bottom:7px;&::placeholder{font-size:20px;}}}span{display:inline-block;margin-top:20px;', ' color:', '}'], _theme.silver, _breakpoints.mobile.max, _theme.blue, _theme.openSansLight, _theme.blue, _theme.openSansLight, _theme.grey, _breakpoints.mobile.max, _theme.openSans, _theme.darkerGrey);

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shareLink = __webpack_require__(329);
	
	var _gaEvent = __webpack_require__(98);
	
	var _gaEvent2 = _interopRequireDefault(_gaEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Twitter Click
	 * @param {string} tweet Tweet hashtag
	 */
	var shareClick = function shareClick(tweet) {
	  (0, _gaEvent2.default)({
	    eventCategory: 'Nav',
	    eventAction: 'Click',
	    eventLabel: tweet
	  });
	};
	
	/**
	 * Copyright Component
	 * @param {object} props Incoming Props
	 * @returns {XML} Copyright Component
	 */
	var ShareButton = function ShareButton(_ref) {
	  var mobile = _ref.mobile,
	      desktop = _ref.desktop;
	  return _react2.default.createElement(
	    _shareLink.ShareLinkWrapper,
	    null,
	    _react2.default.createElement(
	      _shareLink.ShareLink,
	      {
	        className: 'nav__' + (mobile ? 'mobile-' : '') + 'link scroll-link ' + (desktop ? 'desktop-only' : '')
	        // data-target="share"
	        // href="https://twitter.com/intent/tweet?hashtags=XFLRewriteTheRules"
	        , name: 'share',
	        'data-event': '#XFL2020',
	        'data-label': 'XFL2020',
	        'aria-label': 'Share Link'
	        // target="_blank"
	        , onClick: function onClick() {
	          return shareClick('#XFL2020');
	        },
	        to: '/#share'
	      },
	      '#XFL',
	      _react2.default.createElement(
	        'span',
	        { className: 'button-red' },
	        '2020'
	      )
	    )
	  );
	};
	
	exports.default = ShareButton;
	module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _share = __webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Share Component
	 * @returns {XML} Share component
	 */
	var Share = function Share() {
	  return _react2.default.createElement(
	    _share.ShareButton,
	    { className: 'share-link', 'data-target': 'share', 'aria-label': 'Open Share Options' },
	    _react2.default.createElement(
	      'span',
	      { className: 'share-link__text', 'data-event': 'Share', 'data-label': 'share' },
	      'Share'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'share-link__icons' },
	      _react2.default.createElement(
	        'div',
	        { className: 'share-link__icons-wrapper' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'share-link__mobile-header mobile-only' },
	          'Share'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'share-link__icon share-link__icon--facebook',
	            target: '_blank',
	            href: 'https://www.facebook.com/sharer.php?u=https://www.xfl.com',
	            title: 'Facebook Page',
	            rel: 'noopener noreferrer'
	          },
	          'Facebook'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'share-link__icon share-link__icon--twitter',
	            target: '_blank',
	            href: 'https://twitter.com/intent/tweet?url=' + 'text=I%20can%E2%80%99t%20wait%20for%20the%20XFL%20to%20come%20back!!%20%23XFL2020',
	            title: 'Twitter Page',
	            rel: 'noopener noreferrer'
	          },
	          'Twitter'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'share-link__icon share-link__icon--mail',
	            href:
	            // eslint-disable-next-line
	            'mailto:?subject=Get%20your%20game%20face%20on.%20The%20XFL%20is%20back.&amp;body=Prepare%20to%20be%20amazed.%20The%20XFL%20makes%20its%20triumphant%20return%20in%202020.%20Learn%20more%20about%20how%20we%E2%80%99re%20revolutionizing%20the%20game%20forever.%20%23XFL2020%20xfl.com',
	            title: 'Email'
	          },
	          'Email'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          className: 'share-link__close-button mobile-only',
	          href: '#share',
	          title: 'Share',
	          'aria-label': 'Close Overlay',
	          rel: 'noopener noreferrer'
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            className: 'circle-svg',
	            xmlns: 'http://www.w3.org/2000/svg',
	            xmlnsXlink: 'http://www.w3.org/1999/xlink',
	            width: '58',
	            height: '58'
	          },
	          _react2.default.createElement('circle', { className: 'circle-svg__circle', r: '19', cx: '50%', cy: '50%', strokeDasharray: '1, 6' }),
	          _react2.default.createElement('circle', {
	            className: 'circle-svg__circle circle-svg__circle--big',
	            r: '27',
	            cx: '50%',
	            cy: '50%',
	            strokeDasharray: '1, 3'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Share;
	module.exports = exports['default'];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _share = __webpack_require__(327);
	
	Object.defineProperty(exports, 'Share', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_share).default;
	  }
	});
	
	var _shareLink = __webpack_require__(326);
	
	Object.defineProperty(exports, 'ShareLink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shareLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ShareLinkWrapper = exports.ShareLink = undefined;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _breakpoints = __webpack_require__(6);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShareLink = /*#__PURE__*/exports.ShareLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	  componentId: 'sc-1lezcnw-0'
	})(['border:2px solid ', ';color:', ';', ' font-size:29px;font-weight:normal;letter-spacing:3px;padding:10px 15px;text-transform:none;.button-red{color:', ';}@media (max-width:', 'px){border:none;margin:0;}'], _theme.lighterBlue, _theme.lighterBlue, _theme.tekoLight, _theme.red, _breakpoints.mobile.max);
	
	var ShareLinkWrapper = /*#__PURE__*/exports.ShareLinkWrapper = _styledComponents2.default.div.withConfig({
	  componentId: 'sc-1lezcnw-1'
	})(['border-left:1px solid ', ';margin:0 0 0 15px;padding:0 30px;'], _theme.grey);

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ShareButton = undefined;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShareButton = /*#__PURE__*/exports.ShareButton = _styledComponents2.default.div.withConfig({
	  componentId: 'sc-1uqbsbs-0'
	})(['top:initial;bottom:20px;.share-link__text{color:', ';}.share-link__icons-wrapper{background:white;}.share-link__icon{background:white;&:after{}}'], _theme.blue);

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCookie = __webpack_require__(203);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _protection = __webpack_require__(321);
	
	var _index = __webpack_require__(347);
	
	var _header = __webpack_require__(292);
	
	var _footer = __webpack_require__(289);
	
	var _footerModal = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.func.isRequired
	};
	
	/**
	 * Global Page Layout
	 * @param {object} param0 Incoming Props
	 * @returns {XML} New Componet
	 */
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  /**
	   * Constructor
	   * @param {object} props Incoming Props
	   */
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.hideModal = _this.hideModal.bind(_this);
	    _this.showModal = _this.showModal.bind(_this);
	    var _props$data = props.data,
	        contactModal = _props$data.contactModal,
	        privacyModal = _props$data.privacyModal,
	        termsModal = _props$data.termsModal;
	
	    var modals = {
	      terms: termsModal ? termsModal.edges[0].node : null,
	      privacy: privacyModal ? privacyModal.edges[0].node : null,
	      contactus: contactModal ? contactModal.edges[0].node : null
	    };
	    _this.state = {
	      modalData: null,
	      showModal: false,
	      modals: modals
	    };
	    return _this;
	  }
	
	  /**
	   * Hide Modal
	   */
	
	
	  Layout.prototype.hideModal = function hideModal() {
	    this.setState({ showModal: false });
	  };
	
	  /**
	   * Show Modal
	   * @param {string} label Content that should apear in the modal
	   */
	
	
	  Layout.prototype.showModal = function showModal(label) {
	    var _props$data2 = this.props.data,
	        contactModal = _props$data2.contactModal,
	        privacyModal = _props$data2.privacyModal,
	        termsModal = _props$data2.termsModal;
	
	    var modals = {
	      terms: termsModal ? termsModal.edges[0].node : null,
	      privacy: privacyModal ? privacyModal.edges[0].node : null,
	      contactus: contactModal ? contactModal.edges[0].node : null
	    };
	    this.setState({
	      showModal: true,
	      modalData: modals[label]
	    });
	  };
	
	  /**
	   * Compiles JSX for a particular page
	   * @return {JSX} JSX for page
	   */
	
	
	  Layout.prototype.renderPage = function renderPage() {
	    var _props = this.props,
	        data = _props.data,
	        children = _props.children;
	    var _state = this.state,
	        modalData = _state.modalData,
	        showModal = _state.showModal,
	        modals = _state.modals;
	
	    return _react2.default.createElement(
	      _index.Page,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: data.site.siteMetadata.title,
	        meta: [{ name: 'description', content: data.site.siteMetadata.description }]
	      }),
	      _react2.default.createElement(_header.Header, { teams: data.allContentfulTeam }),
	      _react2.default.createElement(
	        'main',
	        { className: 'main' },
	        children(),
	        _react2.default.createElement(_footer.Footer, { modals: modals, showModal: this.showModal, teams: data.allContentfulTeam })
	      ),
	      showModal ? _react2.default.createElement(_footerModal.FooterModal, _extends({}, modalData, { close: this.hideModal })) : ''
	    );
	  };
	
	  /**
	   * Renders the component
	   * @returns {XML} Site layout
	   */
	
	
	  Layout.prototype.render = function render() {
	    var data = this.props.data;
	
	    var isCloudfront = false;
	    if (typeof window !== 'undefined' && window.location.href.indexOf('.cloudfront.net') > -1) {
	      isCloudfront = true;
	    }
	    if (data.site.siteMetadata.passProtect === 'true' || isCloudfront) {
	      return _react2.default.createElement(
	        _reactCookie.CookiesProvider,
	        null,
	        _react2.default.createElement(
	          _protection.Protection,
	          null,
	          this.renderPage()
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.renderPage()
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = propTypes;
	
	exports.default = Layout;
	// eslint-disable-next-line
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Page = undefined;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = /*#__PURE__*/exports.Page = _styledComponents2.default.div.withConfig({
	  componentId: 'v3g6vp-0'
	})(['position:relative;.main{background:none;padding-bottom:0;}']);

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5caf7aa15b4c3594fb65.js